export const environmentToIssuer = new Map([
    ['SINT', 'https://sso.dev.ocp.webapp.idst.ibaintern.de/auth/realms/OCP'],
    ['PINT', 'https://sso.dev.ocp.webapp.idst.ibaintern.de/legacy/pint/auth/realms/OCP'],
    ['Lasttest', 'https://sso.dev.ocp.webapp.idst.ibaintern.de/lasttest/auth/realms/OCP'],
    ['SP1', 'https://sso.dev.ocp.webapp.idst.ibaintern.de/legacy/ssp1/auth/realms/OCP'],
    ['SP2', 'https://sso.dev.ocp.webapp.idst.ibaintern.de/legacy/ssp2/auth/realms/OCP'],
    ['SP3', 'https://sso.dev.ocp.webapp.idst.ibaintern.de/legacy/ssp3/auth/realms/OCP'],
    ['PREPROD', 'https://sso.arbeitsagentur.de/preprod/auth/realms/OCP'],
    ['EDUPUB', 'https://sso.arbeitsagentur.de/edupub/auth/realms/OCP'],
    ['PROD', 'https://sso.arbeitsagentur.de/auth/realms/OCP'],
]);
export const links = {
    [environmentToIssuer.get('SINT')]: {
        zumProfil: 'https://web.dev.ocp.webapp.idst.ibaintern.de/profil-sint/profil-ui/pd/',
        profilBearbeiten: 'https://web.dev.ocp.webapp.idst.ibaintern.de/profil-sint/profil-ui/pd/einstellungen/',
        postfach: 'https://www.todo.sint.com/postfach/not-relevant-for-2402',
        vermittlungsPostfach: 'https://jobboerse-k8s-sint.webapp.idst.ibaintern.de/vamJB/postfachUebersichtAnzeigen.html',
        leistungsPostfach: 'https://web.dev.ocp.webapp.idst.ibaintern.de/kokos-ui-rc-sint/kokos-ui/pd/',
        kontoEinstellungen: 'https://web.dev.ocp.webapp.idst.ibaintern.de/oiambk-sint/oiambk-selfservice-ui/konto-verwalten',
    },
    [environmentToIssuer.get('PINT')]: {
        zumProfil: 'https://web.dev.ocp.webapp.idst.ibaintern.de/profil-pint/profil-ui/pd/',
        profilBearbeiten: 'https://web.dev.ocp.webapp.idst.ibaintern.de/profil-pint/profil-ui/pd/einstellungen/',
        postfach: 'https://www.todo.pint.com/postfach/not-relevant-for-2402',
        vermittlungsPostfach: 'https://jobboerse-k8s-pint.webapp.idst.ibaintern.de/vamJB/postfachUebersichtAnzeigen.html',
        leistungsPostfach: 'https://web.dev.ocp.webapp.idst.ibaintern.de/kokos-ui-rc-pint/kokos-ui/pd/',
        kontoEinstellungen: 'https://web.dev.ocp.webapp.idst.ibaintern.de/oiambk-pint/oiambk-selfservice-ui/konto-verwalten',
    },
    [environmentToIssuer.get('Lasttest')]: {
        zumProfil: 'https://www.todo.lasttest.com/zumProfil',
        profilBearbeiten: 'https://www.todo.lasttest.com/profilBearbeiten',
        postfach: 'https://www.todo.lasttest.com/postfach/not-relevant-for-2402',
        vermittlungsPostfach: 'https://www.todo.lasttest.com/vermittlungsPostfach',
        leistungsPostfach: 'https://www.todo.lasttest.com/leistungsPostfach',
        kontoEinstellungen: 'https://www.todo.lasttest.com/kontoEinstellungen',
    },
    [environmentToIssuer.get('SP1')]: {
        zumProfil: 'https://www.todo.ssp1.com/zumProfil',
        profilBearbeiten: 'https://www.todo.ssp1.com/profilBearbeiten',
        postfach: 'https://www.todo.ssp1.com/postfach/not-relevant-for-2402',
        vermittlungsPostfach: 'https://www.todo.ssp1.com/vermittlungsPostfach',
        leistungsPostfach: 'https://www.todo.ssp1.com/leistungsPostfach',
        kontoEinstellungen: 'https://www.todo.ssp1.com/kontoEinstellungen',
    },
    [environmentToIssuer.get('SP2')]: {
        zumProfil: 'https://www.todo.ssp2.com/zumProfil',
        profilBearbeiten: 'https://www.todo.ssp2.com/profilBearbeiten',
        postfach: 'https://www.todo.ssp2.com/postfach/not-relevant-for-2402',
        vermittlungsPostfach: 'https://www.todo.ssp2.com/vermittlungsPostfach',
        leistungsPostfach: 'https://www.todo.ssp2.com/leistungsPostfach',
        kontoEinstellungen: 'https://www.todo.ssp2.com/kontoEinstellungen',
    },
    [environmentToIssuer.get('SP3')]: {
        zumProfil: 'https://www.todo.ssp3.com/zumProfil',
        profilBearbeiten: 'https://www.todo.ssp3.com/profilBearbeiten',
        postfach: 'https://www.todo.ssp3.com/postfach/not-relevant-for-2402',
        vermittlungsPostfach: 'https://www.todo.ssp3.com/vermittlungsPostfach',
        leistungsPostfach: 'https://www.todo.ssp3.com/leistungsPostfach',
        kontoEinstellungen: 'https://www.todo.ssp3.com/kontoEinstellungen',
    },
    [environmentToIssuer.get('PREPROD')]: {
        zumProfil: 'https://www.todo.preprod.com/zumProfil',
        profilBearbeiten: 'https://www.todo.preprod.com/profilBearbeiten',
        postfach: 'https://www.todo.preprod.com/postfach/not-relevant-for-2402',
        vermittlungsPostfach: 'https://www.todo.preprod.com/vermittlungsPostfach',
        leistungsPostfach: 'https://www.todo.preprod.com/leistungsPostfach',
        kontoEinstellungen: 'https://www.todo.preprod.com/kontoEinstellungen',
    },
    [environmentToIssuer.get('EDUPUB')]: {
        zumProfil: 'https://www.todo.edupub.com/zumProfil',
        profilBearbeiten: 'https://www.todo.edupub.com/profilBearbeiten',
        postfach: 'https://www.todo.edupub.com/postfach/not-relevant-for-2402',
        vermittlungsPostfach: 'https://www.todo.edupub.com/vermittlungsPostfach',
        leistungsPostfach: 'https://www.todo.edupub.com/leistungsPostfach',
        kontoEinstellungen: 'https://www.todo.edupub.com/kontoEinstellungen',
    },
    [environmentToIssuer.get('PROD')]: {
        zumProfil: 'https://web.arbeitsagentur.de/profil/profil-ui/pd/',
        profilBearbeiten: 'https://web.arbeitsagentur.de/profil/profil-ui/pd/einstellungen/',
        postfach: 'https://www.todo.prod.com/postfach/not-relevant-for-2402',
        vermittlungsPostfach: 'https://jobboerse.arbeitsagentur.de/vamJB/postfachUebersichtAnzeigen.html',
        leistungsPostfach: 'https://web.arbeitsagentur.de/kokos/kokos-ui/pd/',
        kontoEinstellungen: 'https://web.arbeitsagentur.de/oiambk/oiambk-selfservice-ui/konto-verwalten',
    },
};
